import React, { Component } from "react";
import Ink from "react-ink";
import Modal from "react-responsive-modal";
import withTracker from "../../../../withTracker";

class Customization extends Component {
  state = {
    open: this.props.isOpen || false,
    addonQuantities: {},
    comment: "",
  };

  handleInput = (event) => {
    this.setState({ comment: event.target.value });
  };

  handlePopupOpen = () => {
    this.setState({ open: true });
    const addonQuantities = {};
    this.props.product.addon_categories.forEach((category) => {
      category.addons.forEach((addon) => {
        addonQuantities[addon.id] = 0;
      });
    });
    this.setState({ addonQuantities });
    this.rerenderInterval = setInterval(() => {
      this.props.forceUpdate();
    }, 100);

    if (this.props.triggerPixelEvent) {
      this.props.triggerPixelEvent("ViewContent", {
        content_name: this.props.product.name,
        content_ids: [this.props.product.id],
        content_type: "product",
        value: this.props.product.price,
        currency: "BRL",
      });
      console.log(
        "Evento ViewContent disparado para:",
        this.props.product.name
      );
    }
  };

  handlePopupClose = () => {
    this.setState({ open: false });
    this.props.forceUpdate();
    clearInterval(this.rerenderInterval);
  };

  shouldDisableButton(addonCategory, addonQuantities) {
    if (addonCategory.select_max === 0) {
      return false;
    }

    const totalSelected = addonCategory.addons.reduce(
      (sum, addon) => sum + addonQuantities[addon.id],
      0
    );

    return totalSelected >= addonCategory.select_max;
  }

  handleChangeQuantity = (addonId, increment, category) => {
    this.setState((prevState) => {
      const addonCategories = this.props.product.addon_categories;
      const addonCategoryIndex = addonCategories.findIndex((cat) =>
        cat.addons.some((addon) => addon.id === addonId)
      );

      if (addonCategoryIndex === -1) return {}; // Se não encontrar a categoria, retorna vazio

      const addonCategory = addonCategories[addonCategoryIndex];
      const updatedQuantities = { ...prevState.addonQuantities };

      const nextCategoryIndex = addonCategoryIndex + 1;

      const scrollToNextCategory = () => {
        setTimeout(() => {
          const nextCategory = document.querySelector(
            `.addon-category-container-${nextCategoryIndex}`
          );

          if (nextCategory) {
            nextCategory.scrollIntoView({ behavior: "smooth" });
          } else {
            console.log("executou");
            const suggestionTextarea = document.querySelector(
              ".form-control.order-comment.mb-30.suggestion-textarea"
            );
            suggestionTextarea.scrollIntoView({ behavior: "smooth" });
          }
        }, 200);
      };

      // Caso seja um radio button (máximo 1)
      if (addonCategory.select_min <= 1 && addonCategory.select_max === 1) {
        updatedQuantities[addonId] = 1;

        addonCategory.addons.forEach((addon) => {
          if (addon.id !== addonId) {
            updatedQuantities[addon.id] = 0;
          }
        });

        scrollToNextCategory();

        return { addonQuantities: updatedQuantities };
      } else {
        // Lógica padrão para incremento/decremento
        const totalInCategory = addonCategory.addons.reduce(
          (sum, addon) => sum + (prevState.addonQuantities[addon.id] || 0),
          0
        );

        const newQuantity =
          (prevState.addonQuantities[addonId] || 0) + increment;

        if (
          (addonCategory.select_max === 0 ||
            totalInCategory + increment <= addonCategory.select_max) &&
          newQuantity >= 0
        ) {
          if (totalInCategory + increment === addonCategory.select_max) {
            scrollToNextCategory();
          }

          return {
            addonQuantities: {
              ...prevState.addonQuantities,
              [addonId]: newQuantity,
            },
          };
        }
      }

      return {};
    });
  };

  _processAddons = (product) => {
    const { comment } = this.state;
    const { addonQuantities } = this.state;
    const addonsByCategory = {};

    product.addon_categories.forEach((category) => {
      addonsByCategory[category.name] = category.addons
        .map((addon) => ({
          quantity: addonQuantities[addon.id] || 0,
          addon,
          category,
        }))
        .filter((item) => item.quantity > 0);
    });

    let hasError = false;

    product.addon_categories.forEach((category) => {
      const totalQuantity = (addonsByCategory[category.name] || []).reduce(
        (sum, item) => sum + item.quantity,
        0
      );
      if (totalQuantity < category.select_min) {
        alert(
          `Você precisa selecionar no mínimo ${category.select_min} opções no complemento ${category.name}.`
        );
        hasError = true;
      }
    });

    if (!hasError) {
      const selectedaddons = Object.values(addonsByCategory)
        .flat()
        .map((item) => ({
          addon_category_name: item.category.name,
          addon_id: item.addon.id,
          addon_name: item.addon.name,
          addon_quantity: item.quantity,
          price: item.addon.price * item.quantity,
          addon_category_order_column: item.category.order_column,
        }));

      this.props.addProduct({ selectedaddons, comment, ...product });
      this.handlePopupClose();
    }
  };

  componentWillUnmount() {
    clearInterval(this.rerenderInterval);
  }

  render() {
    const { product } = this.props;
    return (
      <React.Fragment>
        <button
          type="button"
          className="btn btn-add-remove"
          style={{
            color: localStorage.getItem("cartColor-bg"),
          }}
          onClick={this.handlePopupOpen}
        >
          <span className="btn-inc">+</span>
          <Ink duration="500" />
        </button>
        <Modal
          open={this.state.open}
          onClose={this.handlePopupClose}
          closeIconSize={32}
        >
          <div
            style={{
              marginTop: "2rem",
              textAlign: "left",
            }}
          >
            <h3 className="mb-2">
              {localStorage.getItem("customizationHeading")}
            </h3>
            <hr className="mb-20 mt-10" style={{ borderColor: "#ccc" }} />
            {product.addon_categories.map((addon_category, index) => (
              <div
                key={addon_category.id}
                className={`addon-category-container-${index}`}
              >
                <p
                  className="addon-category-name mb-2"
                  style={{ borderRadius: "1rem" }}
                >
                  {addon_category.name}{" "}
                  <span className="addon-label-price ml-1">
                    {"Min: " +
                      addon_category.select_min +
                      " / Max: " +
                      addon_category.select_max}
                  </span>
                </p>
                {addon_category.addons.map((addon) => (
                  <div
                    key={addon.id}
                    className="form-group addon-list"
                    onClick={() =>
                      this.handleChangeQuantity(addon.id, 1, addon_category)
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex flex-column">
                      <div className="d-flex justify-content-between align-items-center">
                        <label className="text addon-label flex-grow-1 text-break">
                          <strong>{addon.name}</strong>{" "}
                          {`${"(R$" + addon.price + ")"}`}
                        </label>
                        {(addon_category.select_min === 0 ||
                          addon_category.select_min === 1) &&
                        addon_category.select_max === 1 ? (
                          <input
                            type="radio"
                            name={addon_category.name}
                            onChange={() =>
                              this.handleChangeQuantity(
                                addon.id,
                                1,
                                addon_category
                              )
                            }
                            style={{ marginLeft: "0.5rem" }}
                            checked={this.state.addonQuantities[addon.id] === 1}
                          />
                        ) : (
                          <div
                            className="btn-group btn-group-sm cart-item-btn"
                            style={{ position: "absolute", right: "14px" }}
                          >
                            <button
                              type="button"
                              className="btn btn-add-remove"
                              style={{
                                color: localStorage.getItem("cartColor-bg"),
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                this.handleChangeQuantity(
                                  addon.id,
                                  -1,
                                  addon_category
                                );
                              }}
                            >
                              <span className="btn-dec">-</span>
                              <Ink duration="500" />
                            </button>
                            <button type="button" className="btn btn-quantity">
                              {this.state.addonQuantities[addon.id]}
                            </button>
                            <button
                              type="button"
                              className="btn btn-add-remove"
                              style={{
                                color: localStorage.getItem("cartColor-bg"),
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                this.handleChangeQuantity(
                                  addon.id,
                                  1,
                                  addon_category
                                );
                              }}
                              disabled={this.shouldDisableButton(
                                addon_category,
                                this.state.addonQuantities
                              )}
                            >
                              <span className="btn-inc">+</span>
                              <Ink duration="500" />
                            </button>
                          </div>
                        )}
                      </div>
                      {!(
                        addon_category.select_min === 0 &&
                        addon_category.select_max === 1
                      ) && (
                        <span className="addon-label-price ml-1">
                          {this.state.addonQuantities[addon.id] > 0
                            ? `${
                                localStorage.getItem("currencySymbolAlign") ===
                                "left"
                                  ? localStorage.getItem("currencyFormat")
                                  : ""
                              }${(
                                addon.price *
                                this.state.addonQuantities[addon.id]
                              ).toFixed(2)}${
                                localStorage.getItem("currencySymbolAlign") ===
                                "right"
                                  ? localStorage.getItem("currencyFormat")
                                  : ""
                              }`
                            : ""}
                        </span>
                      )}
                      {addon.description && (
                        <p
                          className="addon-description text-muted medium mb-0"
                          style={{ marginTop: "4px" }}
                        >
                          {addon.description}
                        </p>
                      )}
                    </div>
                  </div>
                ))}
                <hr className="mb-20" />
              </div>
            ))}
            <button
              className="btn btn-lg btn-customization-done"
              onClick={() => this._processAddons(product)}
              style={{
                backgroundColor: localStorage.getItem("cartColorBg"),
                color: localStorage.getItem("cartColorText"),
              }}
            >
              {localStorage.getItem("customizationDoneBtnText")}
            </button>
          </div>
          <textarea
            className="form-control order-comment mb-30 suggestion-textarea"
            type="text"
            placeholder={localStorage.getItem("cartSuggestionPlaceholder")}
            onChange={this.handleInput}
            value={this.state.comment || ""}
            rows="1"
          />
        </Modal>
      </React.Fragment>
    );
  }
}

export default withTracker(Customization);
